var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chart-wrapper" },
    [
      _c("div", { attrs: { id: "chart" } }),
      _vm._v(" "),
      _vm.withCanvas
        ? [
            _c("div", { staticClass: "canvas-wrap" }, [
              _c("canvas", {
                attrs: {
                  id: "chart-canvas",
                  width: this.svgWidth,
                  height: this.maxHeight,
                },
              }),
            ]),
            _vm._v(" "),
            _vm.withDownload
              ? _c("p", { staticClass: "submit" }, [
                  _c("label", [_vm._v("File Download Name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.dlName,
                        expression: "dlName",
                      },
                    ],
                    domProps: { value: _vm.dlName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.dlName = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button button-primary",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.download.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("Download")]
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }